import * as util from '../util';

export const keyCodes = {
  enter: 13,
  lshift: 16,
  escape: 27,
  arrow_left: 37,
  arrow_up: 38,
  arrow_right: 39,
  arrow_down: 40,
  r: 82,
  w: 87,
};

export class KeyboardHandler {
  constructor(imageEngine) {
    this.imageEngine = imageEngine;
    this.keysPressed = new Array(256);

    this._keyDown = this._keyDown.bind(this);
    this._keyUp = this._keyUp.bind(this);
  }

  registerEventListeners(container) {
    container.addEventListener('keydown', this._keyDown);
    container.addEventListener('keyup', this._keyUp);
  }

  unregisterEventListeners(container) {
    container.removeEventListener('keydown', this._keyDown);
    container.removeEventListener('keyup', this._keyUp);
  }

  isKeyDown(which) {
    if (which < 0 || which >= 256) return false;
    return this.keysPressed[which];
  }

  _keyDown(e) {
    if (!this.imageEngine.renderer) return;

    var keyCode = e.which;
    if (keyCode >= 0 && this.keysPressed.length) {
      this.keysPressed[keyCode] = true;
    }

    if (util.debug) {
      if (e.keyCode === keyCodes.w) {
        //for (var i = 0; i < this.imageEngine.facade.windows.length; i++) {
        //	this.imageEngine.facade.windows[i].toggleWireframe();
        //}
        this.imageEngine.facade.rebuild();
      } else if (e.keyCode === keyCodes.r) {
        this.imageEngine.facade.rebuild();
      }
    }

    if (
      e.which === keyCodes.escape &&
      this.imageEngine.inputHandler.isInputOpen()
    ) {
      this.imageEngine.interactionHandler.clearSelectedObjects();
      this.imageEngine.inputHandler.closeInputs();
    }

    this.imageEngine.inputHandler.onKeyDown(e);
  }

  _keyUp(e) {
    if (!this.imageEngine.renderer) return;

    var keyCode = e.which;
    if (keyCode >= 0 && this.keysPressed.length) {
      this.keysPressed[keyCode] = false;
    }
  }
}
